/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Country_Change_Official_TitleInputs */



/**
* | output |
* | --- |
* | "Change this official's country?" |
*
* @param {User_Country_Change_Official_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_country_change_official_title = /** @type {((inputs?: User_Country_Change_Official_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Country_Change_Official_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier le pays de cet officiel ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Cambiar el país de este oficial?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alterar o país deste oficial?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modificare il paese di questo ufficiale?")
	return /** @type {LocalizedString} */ ("Change this official's country?")
});